<template>
    <mdb-container fluid>    
        <mdb-row class="justify-content-md-center bg-cover" :style="'background: #FFF url('+layoutData.BACKGROUNDIMG+') no-repeat; min-height:'+screen_height+ ';'" v-if="shwlayout">
            
           <div :style="'width:'+layoutData['box_width']" class="custom_login_outer" role="main">            
                <mdb-card class="login-box" :style="'background:'+layoutData['background_color']">
                <mdb-card-body>
                    <p v-html="layoutData['COMPANYANNOUNCEMENTLABEL']"></p>                   
                <label class="text-center h4 mb-4" v-html="layoutData['COMPANYUSERNAMELABEL_SECONDLOGIN']"></label>
                <div class="grey-text text-center">
                    <select  name="company_name_alter" class="company_chooser" aria-label="choose company" v-model="company_drop" ref="company_drop_ref" >
                        <option value="" v-html="layoutData.COMPANYUSERNAMELABEL_SECONDLOGIN" ></option>
                        <template v-for="(company_item,ky) in company_arr.company_list">
                        <option :value="company_item['company_username']" :key="ky" v-html="company_item['company_username']"></option>
                        </template>
                    </select>                
                <mdb-input v-if="(layoutData['COMPANYPASSWORD'])" type="hidden" v-model="pass"/>
                <mdb-input v-if="(layoutData['COMPANYPASSWORD'])" type="hidden" value="1" v-model="encrypt_flag"/>
                
                </div>
                <div class="text-center">
                <mdb-btn v-on:click="validateLogin" class="btn-login">Login</mdb-btn>
                </div>
                <div class="text-center" role="alert">
                    <mdb-badge pill color="white" :v-if="err" >{{err}}</mdb-badge>
                </div>              
                </mdb-card-body>
                </mdb-card>            
           </div>           
            <mdb-col lg ="12" class="text-center-align" role="contentinfo">
                <p v-html="layoutData['LOGINFOOTER']"></p>
            </mdb-col>                  
        </mdb-row>        
  </mdb-container>
</template>

<script>
import axios from 'axios';
import { mdbRow, mdbContainer, mdbCol, mdbInput, mdbBtn,mdbCard, mdbCardBody,mdbBadge  } from 'mdbvue';
export default {
    name: 'Body',
    data(){
        return{user:'', encrypt_flag:0,screen_height:'auto',
        pass:'',message:'',err:'',layoutData:[],company_arr:[],company_drop:'', shwlayout:0}
    },
    components:{
        mdbContainer,
        mdbRow,
        mdbCol,mdbInput, mdbBtn,mdbCard, mdbCardBody, mdbBadge 
    },
    created (){
        this.getLayout();
        document.documentElement.setAttribute("lang", "en");
        Weglot.switchTo('en');
        document.title="Login";
    },
    mounted :function(){
        this.showCompanyDropdown()
    },   
    methods:{
        getLayout(){
            this.screen_height=window.innerHeight+'px';
            if(this.$store.state.companyData['custom_login'] === undefined || this.$store.state.companyData['custom_login'].length == 0){
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            formData.append('id_eap', this.$route.params.company_id)
            formData.append('filename', this.$route.params.file_name)            
           
            axios.post(this.$store.state.apiUrl+'/login_page',formData,config)
            .then(response => {
                response = response.data
               /* if(response === undefined || response.length == 0 ){
                    //console.log('invalid')
                    this.err='! Invalid Credential / No Access'
                }
                else{*/
                //console.log('ttt-'+response.COMPANYANNOUNCEMENTLABEL)
                    this.layoutData=response;
                    this.$store.state.companyData['custom_login'] = response
                    //this.pass=response.COMPANYPASSWORD
                    //this.user=response.COMPANYUSERNAME
                    if(response.COMPANYPASSWORD){
                        this.encrypt_flag=1
                    }
                    
                    //console.log('tttuyuyu-'+this.layoutData.COMPANYANNOUNCEMENTLABEL)
                   
                //}
                
            })
            .catch(() => {
                this.layoutData = [];
                this.err='Try after sometime'
            });
            //event.preventDefault();
            }else{
                this.layoutData=this.$store.state.companyData['custom_login'];
                this.pass=this.$store.state.companyData['custom_login'].COMPANYPASSWORD;
                this.user=this.$store.state.companyData['custom_login'].COMPANYUSERNAME;
                if(this.pass){
                    this.encrypt_flag=1
                }
            }

        },

        showCompanyDropdown(){
            var api_private_key=this.get_api_key_mix('cost')   
            axios.get(this.$store.state.apiUrl+'/company_list',{
              params:{                  
                  id_eap:this.$route.params.company_id,
                  entered_text:this.pass,
                  filename:this.$route.params.file_name,
                  privatekey:api_private_key     
              }
          })
          .then(response => {
              response = response.data,
              this.company_arr = response,
              this.pass=response.company_password 
              if(response.company_list.length <= 0){
                sessionStorage.setItem('login_err_display','Your login information is incorrect.');
                this.$router.push({path:'/CompanyLogin/'+this.$route.params.company_id+'/'+this.$route.params.file_name})     
                return false 
              }          
              this.shwlayout = 1;              
          })
          .catch((error) => {
              this.company_arr = [];
              this.customErrorHandler(error.response.status);
          });
      },
        
        validateLogin:function(){
           //alert('in mdb login');
           this.err="";
            if(this.company_drop==''){
                this.err='Choose a value'
                this.$refs.company_drop_ref.focus();
                return false;
            }
            
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            const formData = new FormData()
            formData.append('username', this.company_drop)
            formData.append('password', this.pass)
            formData.append('encrypt_flag', this.encrypt_flag)
            formData.append('id_eap', this.$route.params.company_id)
            formData.append('filename', this.$route.params.file_name)
            formData.append('origref', document.referrer)
           
            axios.post(this.$store.state.apiUrl+'/login',formData,config)
            .then(response => {
                var messageer= response.data;
                response = response.data[0]
                if(response === undefined || response.length == 0 ){
                     if(messageer.message){
                        this.err=messageer.message;
                    }
                    else{
                        this.err='! Invalid Credential or No Access'
                    }
                    //this.user = '';
                    //this.pass= '';
                    this.$refs.company_drop_ref.focus();
                }
                else{
                    this.$store.state.companyData=response
                    this.$store.state.companyData['custom_text_1'] = response.custom_text_1
                    this.$store.state.companyData['custom_text_2'] = response.custom_text_2
                    this.$store.state.companyData['custom_text_3'] = response.custom_text_3
                    this.$store.state.companyData['custom_text_4'] = response.custom_text_4
                    this.$store.state.companyData['custom_text_5'] = response.custom_text_5
                    this.$store.state.companyData['id_company'] = response.id_company
                    this.$store.state.companyData['encrypt_key'] = response.encrypt_key
                    
                    this.$store.state.companyData['id_design'] = response.id_design
                    this.$store.state.companyData['id_eap'] = response.id_eap
                    this.$store.state.companyData['filename'] = response.filename
                    this.$store.state.companyData['id_service'] = response.id_service
                    this.$store.state.companyData['name_company'] = response.name_company
                    this.$store.state.companyData['name_css'] = response.name_css
                    this.$store.state.companyData['id_language'] = response.language_id_default.substr(3,3)
                    this.$store.state.companyData['id_country'] = response.language_id_default.substr(0,3)
                    this.$store.state.companyData['id_session'] = response.id_session
                    this.$store.state.companyData['login_user'] = response.logname 
                    this.$store.state.companyDataInfo.company_logo=response.company_logo
                    localStorage.company_logo=response.company_logo 
                    localStorage.id_company = response.id_company;
                    localStorage.id_design = response.id_design;
                    localStorage.id_eap = response.id_eap;
                    localStorage.id_service = response.id_service;
                    localStorage.id_service_link = response.id_service_link;
                    localStorage.id_language = response.language_id_default.substr(3,3);
                    localStorage.id_country = response.language_id_default.substr(0,3);
                    localStorage.custom_text_1 = response.custom_text_1;
                    localStorage.encrypt_key = response.encrypt_key;
                    localStorage.name_company = response.name_company;
                    localStorage.custom_text_2 = response.custom_text_2;
                    localStorage.custom_text_3 = response.custom_text_3;
                    localStorage.custom_text_4 = response.custom_text_4;
                    localStorage.custom_text_5 = response.custom_text_5;
                    localStorage.filename = response.filename;
                    localStorage.id_session = response.id_session;
                    localStorage.login_user = response.logname;
                    //console.log('w-',this.$store.state.companyData )
                    if(response.language_id_default==""){                     
                      this.$router.push({path:'/languageChooser'})     
                      return false                 
                    }
                    //api_private_key=this.$store.state.generate_privatekey('geme')
                    this.$store.dispatch('getTheme');
                    this.$store.dispatch('getLanguageTerms');
                    this.$store.dispatch('getThemeLogic');
                    this.$store.dispatch('getCompanyDataInfo');
                    this.$router.push({path:'/'})
                }
                
            })
            .catch(() => {
                this.company_data = [];
                this.err='Try after sometime'
            });
            event.preventDefault();
        }
    } 
};
</script>
<style scoped>
.login-box{
    margin-top: 15px;    
    padding: 10px;
    background-color: #ffffffd1;
    margin-bottom: 50px;
}
.badge{
    font-size: 85%;
    white-space: inherit;
    padding: 7px;
}
.col-md-4{
    padding-left: 2px;
}
.btn-login{
    background-color: #245d89 !important;    
    color: #fff !important;
}
.btn-login:focus {
    background-color: #186860 !important;
    outline: 2px dotted #e9f8ff !important;
    border: 2px dotted #1d1d1d !important;
    outline-offset: -1px !important;
}
.text-center span{
    color: #D3350D !important;
}
.bg-cover{
    background-size: cover !important; 
    background-position: center center !important;
    background-repeat: no-repeat !important;
}
.text-center-align{
    text-align: center !important;
}

.justify-content-md-center {
    -ms-flex-pack: center!important;
    -webkit-box-pack: center!important;
    justify-content: center!important;
}
@media screen and (max-width: 767px) {
    .custom_login_outer{
        min-width: 85%;
    }
}
.company_chooser{
    width: 100%;   
}
</style>
